module.exports = "/_next/static/images/PersonalizeOnEveryChannelMobile-0c531436e7b937418bc74e13a6d049ac.webp";